var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.enemy ? _c('div') : _c('div', [_c('v-list-item', {
    attrs: {
      "to": "/enemy/".concat(_vm.id, "?level=").concat(_vm.level, "&qid=").concat(_vm.qid)
    }
  }, [_vm.collection ? [_c('v-list-item-avatar', {
    attrs: {
      "size": 48
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.ordericon.format(_vm.enemy.m_ResourceID) + '.jpg'
    }
  })], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$name(_vm.enemy.m_CharaName)))])], 1)] : [_c('v-list-item-avatar', {
    staticClass: "mr-2",
    attrs: {
      "size": _vm.$size(48)
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.ordericon.format(_vm.enemy.m_ResourceID) + '.jpg'
    }
  })], 1), _c('v-list-item-content', {
    staticClass: "hidden-md-and-up"
  }, [_c('v-list-item-title', {
    staticClass: "d-flex align-center"
  }, [_c('img', {
    staticClass: "d-inline",
    attrs: {
      "width": _vm.$size() / 3,
      "height": _vm.$size() / 3,
      "src": _vm.$asset.commonuiatlas.format(_vm.elementIcon) + '.png'
    }
  }), _c('span', {
    staticClass: "pl-1"
  }, [_vm._v(_vm._s(_vm.$name(_vm.enemy.m_CharaName)))]), _c('v-list-item-subtitle', {
    staticClass: "pl-1"
  }, [_vm._v(_vm._s(_vm.$t('Level')) + " " + _vm._s(_vm.level))])], 1), _c('v-list-item-subtitle', [_c('Status', {
    attrs: {
      "status": _vm.status6,
      "divide": "3",
      "format": ""
    }
  })], 1)], 1), _c('v-list-item-content', {
    staticClass: "hidden-sm-and-down"
  }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$name(_vm.enemy.m_CharaName)))]), _c('v-list-item-subtitle', {
    staticClass: "d-flex align-center"
  }, [_c('img', {
    staticClass: "d-inline",
    attrs: {
      "width": _vm.$size() / 3,
      "height": _vm.$size() / 3,
      "src": _vm.$asset.commonuiatlas.format(_vm.elementIcon) + '.png'
    }
  }), _c('span', {
    staticClass: "pl-1"
  }, [_vm._v(_vm._s(_vm.$t('Level')) + " " + _vm._s(_vm.level))])])], 1)]], 2), !_vm.collection ? _c('div', {
    staticClass: "px-2 mb-4 hidden-sm-and-down small"
  }, [_c('Status', {
    attrs: {
      "status": _vm.status7,
      "divide": "2",
      "format": ""
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }